import React, { Component } from 'react';
import './styles.scss';
import { connect } from 'react-redux';

import ButtonGroup from '../ReduxFormFields/ButtonGroup';
import { Box, HorizontalFormControl } from '../../../../../../common/components';
import { Field, getFormValues } from 'redux-form';
import { Col, Row, FormGroup, ControlLabel } from 'react-bootstrap';

export class Regulation extends Component {
  render() {
    const { content } = this.props;

    return (
      <Box className="broker-application-regulation">
        <Row>
          <Col sm={12}>
            <h4 className="page-title">Regulation</h4>
            <hr />
          </Col>
        </Row>
        {content.fields.map((field) => {
          switch (field.type) {
            case 'input': {
              return (
                <Field
                  name={field.name}
                  key={field.name}
                  labelSize={5}
                  fieldSize={7}
                  component={HorizontalFormControl}
                  label={field.label}
                />
              );
            }
            case 'question': {
              return (
                <FormGroup key={field.name}>
                  <Col sm={9}>
                    <ControlLabel>{field.label}</ControlLabel>
                  </Col>
                  <Col sm={3}>
                    <div className={'broker-application-answers'}>
                      <Field
                        name={`${field.name}`}
                        component={ButtonGroup}
                        inline
                        options={[
                          { label: 'Yes', value: true },
                          { label: 'No', value: false },
                        ]}
                      />
                    </div>
                  </Col>
                </FormGroup>
              );
            }
          }
        })}
      </Box>
    );
  }
}

export default connect((state, props) => {
  return {
    formValues: getFormValues(props.form)(state),
  };
})(Regulation);
